import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Button, Skeleton, Typography } from '@mui/material';
import { serverService } from '../../services/api';
import { INK, MUTED, RULE, Section, formatCount, formatINR } from '../analytics/analyticsUi';

const GOOD = '#0D7332';
const BAD = '#C2410C';

// Admin dashboard: what the servers cost this month, against what the clients on them bring in
const HostingCostCard = () => {
  const [totals, setTotals] = useState(null);
  const [failed, setFailed] = useState(null);

  useEffect(() => {
    serverService.list()
      .then((response) => setTotals(response.data?.totals || null))
      .catch((err) => setFailed(err.response?.data?.error || err.message || 'Could not be loaded'));
  }, []);

  return (
    <Section
      title="Hosting cost"
      action={
        <Button size="small" component={RouterLink} to="/admin/servers" sx={{ textTransform: 'none', flexShrink: 0 }}>
          Servers
        </Button>
      }
    >
      {failed ? (
        <Typography variant="body2" sx={{ color: MUTED }}>
          Hosting cost could not be loaded ({failed}). Refresh the page to try again.
        </Typography>
      ) : !totals ? (
        <Skeleton variant="rounded" height={132} />
      ) : (
        <Box sx={{ fontVariantNumeric: 'tabular-nums' }}>
          <Typography variant="body2" sx={{ color: MUTED }}>
            Client hosting, {formatCount(totals.hostingServers)} {totals.hostingServers === 1 ? 'server' : 'servers'}
          </Typography>
          <Typography sx={{ fontSize: '1.5rem', fontWeight: 600, color: INK, letterSpacing: '-0.01em' }}>
            {formatINR(totals.hostingCost)}
          </Typography>
          <Typography variant="caption" sx={{ color: MUTED }}>
            {formatCount(totals.clients)} clients on them
          </Typography>

          <Box sx={{ mt: 2, pt: 1.75, borderTop: `1px solid ${RULE}`, display: 'grid', gridTemplateColumns: '1fr auto', rowGap: 1, columnGap: 2 }}>
            <Typography variant="body2" sx={{ color: MUTED }}>Plan revenue</Typography>
            <Typography variant="body2" sx={{ color: INK, fontWeight: 600 }}>{formatINR(totals.planRevenue)}</Typography>

            <Typography variant="body2" sx={{ color: MUTED }}>Less hosting</Typography>
            <Typography variant="body2" sx={{ color: totals.margin >= 0 ? GOOD : BAD, fontWeight: 600 }}>
              {formatINR(totals.margin)}
            </Typography>

            <Typography variant="body2" sx={{ color: MUTED }}>Bots, calls, webhook, VPN</Typography>
            <Typography variant="body2" sx={{ color: INK }}>{formatINR(totals.internalCost)}</Typography>

            <Typography variant="body2" sx={{ color: INK, fontWeight: 600 }}>All servers</Typography>
            <Typography variant="body2" sx={{ color: INK, fontWeight: 600 }}>{formatINR(totals.monthlyCost)}</Typography>
          </Box>

          <Typography variant="caption" sx={{ color: MUTED, display: 'block', mt: 1.5 }}>
            {totals.month}. Revenue counts only the clients linked to a customer.
          </Typography>
        </Box>
      )}
    </Section>
  );
};

export default HostingCostCard;
